var map = {
	"./communityVideo-1.mp4": 9235,
	"./communityVideo-10.mp4": 7074,
	"./communityVideo-11.mp4": 8283,
	"./communityVideo-12.mp4": 6648,
	"./communityVideo-13.mp4": 8494,
	"./communityVideo-14.mp4": 833,
	"./communityVideo-15.mp4": 7499,
	"./communityVideo-16.mp4": 4621,
	"./communityVideo-17.mp4": 3790,
	"./communityVideo-18.mp4": 4244,
	"./communityVideo-19.mp4": 9304,
	"./communityVideo-2.mp4": 8218,
	"./communityVideo-20.mp4": 8974,
	"./communityVideo-3.mp4": 403,
	"./communityVideo-4.mp4": 155,
	"./communityVideo-5.mp4": 3503,
	"./communityVideo-6.mp4": 1126,
	"./communityVideo-7.mp4": 7962,
	"./communityVideo-8.mp4": 9720,
	"./communityVideo-9.mp4": 9291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1366;